import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import ChainedBackend from 'i18next-chained-backend';
import HttpBackend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import { getCustomerCodeOrDefault } from '@lib/common';

const customerCode = getCustomerCodeOrDefault('armadillo');

console.log("Customer", customerCode);

i18n
  .use(ChainedBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    lang: 'en-US',
    fallbackLng: 'en-US',
    
    ns: [customerCode, 'default'],
    defaultNS: customerCode,
    fallbackNS: 'default',

    interpolation: {
      escapeValue: false,
    },

    backend: {
      backends: [
        HttpBackend,
        // if we need to support overlay with embedded resources, we can follow this example
        // https://github.com/i18next/i18next-http-backend/blob/master/example/fallback/app.js
      ],
      backendOptions: [{
        loadPath: '/locales/{{ns}}/{{lng}}.json'
      }]
    }
  });

  export default i18n;